export default "__VITE_ASSET__DHuz7u3v__"